import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import { reducerCrud, reducerList } from 'scorpion-core';

export default combineReducers({
    rCrudSalvar: reducerCrud(TypeAction.SALVAR),
    rLista: reducerList(TypeAction.LISTAR),
})


// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/reducer.js